<template>
  <Modal :id="'cmp-assign-invoice-contact'" @cancelled="onCancel">
    <template slot="header">{{ $t("find_contact") }}</template>

    <template slot="body">
      <div class="contact-search">
        <InputField
          :id="'contact_search'"
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'around',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>

      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
              'margin-right': hRowMarginRight,
            }"
          >
            <th class="dt-table2--column">{{ $t("name") }}</th>
            <th class="dt-table2--column">{{ $t("address") }}</th>
            <th class="dt-table2--column">{{ $t("mail") }}</th>
            <th class="dt-table2--column">{{ $t("telephone") }}</th>
          </tr>
        </thead>
        <tbody class="dt-table2--body">
          <tr
            class="dt-table2--row"
            v-for="contact in contacts"
            :key="contact.contact_id"
            @click="(e) => onRowClicked(contact)"
          >
            <td class="dt-table2--column">{{ contact["contact_name"] }}</td>
            <td class="dt-table2--column">{{ contact["address1"] }}</td>
            <td class="dt-table2--column">{{ contact["email1"] }}</td>
            <td class="dt-table2--column">{{ contact["phone1"] }}</td>
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click="onCancel">{{ $t("cancel") }}</button>
      <button
        class="dt-button v1 with-ico s6"
        @click="onAddContactClick"
        :class="{ disabled: !searchString }"
        :disabled="!searchString"
      >
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">{{ $t("Create") }} {{ $t("contact") }}</div>
      </button>
      <v-dialog persistent v-model="createContactModal" width="390">
        <AddContact
          @new_contact="onNewContactDone"
          @cancelled="onaddContactCancelled"
        />
      </v-dialog>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { ContactService } from "../../../../dt-plugins/add-contact-relation/contact.service";
import InputField from "../../../../plugins/text-field/text-field";
import {
  createModalMixin,
  openModal2Route,
  closeModal2Route,
} from "../../../../dt-plugins/modal/modal.mixin";
import { Subject } from "rxjs";
import { subscribeSubject } from "../../../../utility";
import { ContactFuncs } from "../../../contacts/models/contacts.model";
import ModalContainer from "@dtplugins/modal/modal-container";
// import AddContact from "./add-contact";
import AddContact from "../../../../dt-plugins/add-contact-relation/add-contact";
import { InvoicesService } from "../../services/invoices.service";
import {
  NotificationService,
  showError,
} from "../../../../dt-plugins/notification/notification.service";

const contactSearchType = "both";

export default {
  props: ["selectedInvoice"],
  components: {
    InputField,
    Modal,
    ModalContainer,
    AddContact,
  },
  mixins: [
    createModalMixin("createContact", [], {
      modalQueryKey: "modal2",
    }),
  ],
  watch: {
    searchString: {
      immediate: true,
      handler: function (to, from) {
        // console.log(`searchString Change to ${to} from ${from}`);
      },
    },
  },
  data: function () {
    return {
      contacts: [],
      searchString: "",
      contactSubject$: new Subject(),

      contactHeaders: ["Name", "Address", "Mail", "Telephone"],
      searchSize: "single",

      groups: [],

      addPersonModalContainer: false,
      addPersonModal: false,

      addCompanyModal: false,
      addCompanyModalContainer: false,

      ContactFuncs: ContactFuncs,
    };
  },
  mounted: function () {
    ContactService.findContacts({
      contactSearchType,
    }).then((contacts) => {
      this.contacts = contacts.data;
    });

    // Artist Subscription
    subscribeSubject(this, this.contactSubject$, (searchString) => {
      // console.warn(searchString);
      ContactService.findContacts({
        searchString,
        contactSearchType,
      }).then((contacts) => {
        this.contacts = contacts.data;
      });
    });
    // this.$subscribeTo(
    //   this.contactSubject$.asObservable().pipe(
    //     debounceTime(300),
    //     distinctUntilChanged()
    //   ),

    // );
  },
  computed: {
    hRowMarginRight: function () {
      if (this.contacts.length > 380 / 28) {
        return "28px";
      }
    },
    config: function () {
      return this.externalTable
        ? getContactRelationConfiguration(this.externalTable)
        : undefined;
    },
    external_id: function () {
      return this.$route.query.external_id;
    },
  },
  methods: {
    onSearchInputKeyup: function (e) {
      this.searchString = e.target.value;
      this.contactSubject$.next(this.searchString);
    },
    searchContact: function () {
      ContactService.searchContacts({
        searchString: this.searchString,
      }).then((contacts) => {
        this.contacts = contacts;
      });
    },
    onRowClicked: async function (contact) {
      // console.log(contact);
      const { contact_id } = contact;
      const invoice_id = this.selectedInvoice?.invoice?.invoice_id;
      // console.log("Log: invoice_id", invoice_id);
      if (!invoice_id) {
        NotificationService.showNotification({
          text: `Invoice ID is not defined`,
          type: "error",
        });
        this.onCancel();
      }
      const invoiceContact = await InvoicesService.setInvoiceContact({
        invoice_id,
        contact_id,
      });
      const contactData = await InvoicesService.findContactData({
        contact_id,
      });
      const vat_handling =
        typeof contactData?.data?.contact?.country == "string" &&
        typeof invoiceContact?.data?.invoice_project?.country == "string" &&
        invoiceContact?.data?.invoice_project?.country.toLowerCase() ==
          contactData?.data?.contact?.country.toLowerCase()
          ? 1
          : 3;
      const modifyInvoiceContact = await InvoicesService.updateInvoiceContact({
        invoice_id,
        invoice_address: contactData?.data?.invoice_address,
        contact_id,
        vat_handling,
      });
      this.$emit("done", contactData);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onaddContactCancelled: function () {
      closeModal2Route(this);
    },
    onAddContactClick: function () {
      openModal2Route(this, "create_contact");
    },
    onNewContactDone: async function (payload) {
      // console.log(payload);
      const { type, contact } = payload;
      try {
        const invoice_id = this.selectedInvoice?.invoice?.invoice_id;
        if (!invoice_id) {
          showError("Invoice ID does not exist");
        }

        let insertedContact;
        if (type === "person") {
          insertedContact = await ContactService.insertPerson(contact);
        } else if (type === "company") {
          insertedContact = await ContactService.insertCompany(contact);
        }

        const contact_id = insertedContact.data.contact_id;
        if (!contact_id) {
          showError("Contact could not be inserted");
        }
        const invoiceContact = await InvoicesService.setInvoiceContact({
          invoice_id,
          contact_id,
        });
        const contactData = await InvoicesService.findContactData({
          contact_id,
        });
        const modifyInvoiceContact = await InvoicesService.updateInvoiceContact(
          {
            invoice_id,
            invoice_address: contactData.data.invoice_address,
            contact_id,
          }
        );
        this.$emit("done", contactData);
      } catch (e) {
        this.$emit("cancelled", true);
      }
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {
  button {
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 0px 10px;
    }
  }
}
</style>
